<template>
  <div>
    <div
      v-for="(user, id) in users"
      :key="id"
      class="d-flex justify-content-between align-items-center py-2 px-4"
      :class="{
        'bg-plain': user.user.id.toString() === userId.toString(),
        'atm-rounded-top': id === 0,
        'atm-rounded-bottom': id === users.length - 1
      }"
    >
      <div class="d-flex justify-content-center align-items-center">
        <span
          class="rankingNumberStyle d-flex justify-content-center align-items-center bg-light2 font-weight-600 rounded-pill"
          :class="{
            'bg-main text-light': id === 0,
            'bg-main-low text-light': user.user.id.toString() === userId.toString()
          }"
        >
          {{ id + 1 }}
        </span>
        <span class="font-weight-600 text-capitalize ml-3">
          {{ user.user.name }}
        </span>
      </div>
      <span class="font-weight-600">{{ user.points }} Pts</span>
    </div>
    <div
      v-if="userPos > 10 && userNumber === levelNumber"
      class="d-flex justify-content-between align-items-center py-2 px-4 bg-plain mt-4 atm-rounded"
    >
      <div class="d-flex justify-content-center align-items-center">
        <span class="rankingNumberStyle d-flex justify-content-center align-items-center bg-main-low text-light font-weight-600 rounded-pill">
          {{ userPos }}
        </span>
        <span class="font-weight-600 text-capitalize ml-3">
          {{ childName }}
        </span>
      </div>
      <span class="font-weight-600">{{ userPoints }} pts</span>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    users: Array,
    levelNumber: Number,
    userPos: Number,
    childName: String,
    userPoints: Number,
    userNumber: Number,
    userId: String,
  },
};
</script>
<style>
.position-std {
  width: 30px;
}

.rankingNumberStyle {
  width: 30px;
  height: 30px;
}
</style>
